export default __webpack_public_path__ + "images/3a49739404b9b0cf6b408df1ab048312.png";